module.exports = __webpack_public_path__ + "static/media/close.91d51a57.svg";